export const isStripeAccountReady = (stripeStatus) => Boolean(
  stripeStatus?.status === 'active' &&
  stripeStatus?.chargesEnabled &&
  stripeStatus?.payoutsEnabled
);

export const isBrandPayoutReady = (brand) => Boolean(
  brand?.bankDetails?.stripeConnectId && brand?.bankDetails?.verified
);

export const getPayoutSetupBrands = ({ brands = [], currentBrand = null } = {}) => (
  currentBrand ? [currentBrand] : brands
);

export const resolvePayoutSetupReady = async ({
  brands = [],
  currentBrand = null,
  getAccountStatus
} = {}) => {
  const setupBrands = getPayoutSetupBrands({ brands, currentBrand });
  if (setupBrands.some(isBrandPayoutReady)) return true;
  if (typeof getAccountStatus !== 'function') return false;

  const connectedBrands = setupBrands.filter(brand => brand?.bankDetails?.stripeConnectId);
  if (connectedBrands.length === 0) return false;

  const results = await Promise.allSettled(
    connectedBrands.map(brand => getAccountStatus(brand._id))
  );

  return results.some(result => (
    result.status === 'fulfilled' && isStripeAccountReady(result.value)
  ));
};
